import { createVideoCallingSlice, type VideoCallingSlice } from "@tellescope/video-calling";
import { createStore } from "./utils";

export const { useStore: useVideoCallingStore, useShallowStore: useVideoCallingShallowStore } =
  createStore<VideoCallingSlice>(
    (set, get) =>
      createVideoCallingSlice(
        (updates) => set((state) => ({ ...state, ...updates })),
        () => get()
      ),
    { name: "VIDEO_CALLING_STORE" }
  );
